import { isly } from "isly";
import { Numeric as NumberNumeric } from "./Numeric";
export var Number;
(function (Number) {
    var _a;
    Number.Numeric = NumberNumeric;
    Number.values = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
    ];
    _a = isly
        .string("value", ...Number.values)
        .rename("isoly.Week.Number")
        .bind(), Number.type = _a.type, Number.is = _a.is, Number.flawed = _a.flawed;
})(Number || (Number = {}));
//# sourceMappingURL=index.js.map